import React, { useState, useEffect } from "react";

import style from "../assets/css/components/Records.module.css";
import classnames from "classnames";

import goal from "../assets/img/allGoal.png";
import offensive from "../assets/img/offensive.png";
import defensive from "../assets/img/defensive.png";
import win from "../assets/img/win.png";

function Records({ data, tournament }) {
  const [stats, setStats] = useState({});

  useEffect(() => {
    const orderData = (data, name) => {
      data.sort(function (a, b) {
        if (a[name] > b[name]) return 1;
        if (a[name] < b[name]) return -1;

        return 0;
      });

      return data;
    };

    if (data) {
      const dataTable = data.generalTables;

      let table = [...dataTable];
      let table2 = [...dataTable];
      let table3 = [...dataTable];

      let totalGoals = 0;

      dataTable.forEach((table) => {
        totalGoals += table.gf;
      });

      let gf = orderData(table, "gf");
      let ge = orderData(table2, "ge");
      let jg = orderData(table3, "jg");

      const gfReverse = gf.reverse();
      const jgReverse = jg.reverse();

      const bestOff = gfReverse[0];
      const bestDef = ge[0];
      const bestTeam = jgReverse[0];

      setStats({
        totalGoals,
        off: { team: bestOff?.team?.name, goals: bestOff?.gf },
        def: { team: bestDef?.team?.name, goals: bestDef?.ge },
        best: { team: bestTeam?.team?.name, wins: bestTeam?.jg },
      });
    }
  }, [data]);

  const logoutAction = () => {
    window.localStorage.clear();
    window.location.reload();
  };

  return (
    <>
      <div className={style.contTitle}>
        <p className={style.titleSection}>Estadisticas</p>
        <p className={style.league} onClick={logoutAction}>
          {/* {tournament} */}
          LIGA FUT 7 JOSÉ F. GOMEZ
        </p>
      </div>
      <div className={style.contItem}>
        <Item
          allGoal={true}
          title="Torneo"
          subtitle="Goles"
          icon={goal}
          score={stats?.totalGoals}
          txtScore="Goles"
        />
        <Item
          title={stats?.off?.team}
          subtitle="Ofensiva"
          icon={offensive}
          score={stats?.off?.goals}
          txtScore="Goles"
        />
        <Item
          title={stats?.def?.team}
          subtitle="Defensiva"
          icon={defensive}
          score={stats?.def?.goals}
          txtScore="Goles"
        />
        <Item
          title={stats?.best?.team}
          subtitle="+ Victorias"
          icon={win}
          score={stats?.best?.wins}
          txtScore="ganados"
        />
      </div>
    </>
  );
}

const Item = ({ allGoal, title, subtitle, icon, score, txtScore }) => (
  <div
    className={
      allGoal
        ? classnames(style.item, style.allGoal)
        : classnames(style.item, style.card)
    }
  >
    <div className={style.headItem}>
      <img className={style.icon} src={icon} alt="" />
      <div className={style.contScore}>
        <p className={style.score}>{score}</p>
        <p className={style.text}>{txtScore}</p>
      </div>
    </div>
    <div className={style.titleItem}>
      <p className={style.subtitle}>{subtitle}</p>
      <p className={style.title}>{title}</p>
    </div>
  </div>
);

export default Records;
